import Layout from '@/layouts/Layout'

const group = {
  path: '/tenant_new',
  component: Layout,
  name: 'tenant_new',
  meta: {
    title: '集团',
  },
  children: [
    {
      path: '/tenant/groupRoleMange/list',
      name: 'tenant_new_role',
      component: () => import('@/pages/organize/groupRoleMange/list/index.vue'),
      meta: { title: '角色管理', logEvent: '' },
    },
    // 审批流
    {
      path: '/tenant/groupApproveFlowConfig/list',
      name: 'tenant_new_approval_config',
      component: () => import('@/pages/approvals/groupApproveFlowConfig/list'),
      meta: { title: '审批流配置', logEvent: '' },
    },
    {
      path: '/tenant/groupApproveFlowConfig/detail',
      name: 'tenant_new_approval_config_list_detail',
      component: () =>
        import('@/pages/approvals/groupApproveFlowConfig/detail'),
      meta: {
        title: '审批流详情',
        logEvent: '',
        parent: {
          path: '/tenant/groupApproveFlowConfig/list',
          name: 'tenant_new_approval_config',
          title: '审批流配置',
        },
      },
    },
    {
      path: '/tenant/groupApproveFlowConfig/edit',
      name: 'tenant_new_approval_config_list_edit',
      component: () => import('@/pages/approvals/groupApproveFlowConfig/edit'),
      meta: {
        title: '审批流编辑',
        logEvent: '',
        parent: {
          path: '/tenant/groupApproveFlowConfig/list',
          name: 'tenant_new_approval_config',
          title: '审批流配置',
        },
      },
    },
    {
      path: '/companyNew/approveList/list',
      name: 'company_new_approval_manage',
      component: () => import('@/pages/approvals/approveList/list'),
      meta: { title: '待我审批', logEvent: '' },
    },
    {
      path: '/companyNew/approveList/detail',
      name: 'company_new_approval_manage_list_detail',
      component: () => import('@/pages/approvals/approveList/detail'),
      meta: {
        title: '审批详情',
        logEvent: '',
        parent: [
          {
            path: '/companyNew/approveList/list',
            name: 'company_new_approval_manage',
            title: '审批列表',
          },
          {
            path: '/companyNew/approveCenter/list',
            name: 'company_new_approval_center',
            title: '审批中心',
          },
        ],
      },
    },
    {
      path: '/companyNew/approveCenter/list',
      name: 'company_new_approval_center',
      component: () => import('@/pages/approvals/approveCenter/list'),
      meta: { title: '审批中心', logEvent: '' },
    },
    // 合同模版
    {
      path: '/tenantNew/contractTemplate/list',
      name: 'tenant_new_contract_template',
      component: () =>
        import(
          '@/pages/organize/Contract/views/ContractTemplateMangment/index.vue'
        ),
      meta: { title: '合同模板管理', logEvent: '', keepAlive: false },
    },
    {
      path: '/tenantNew/contractTemplate/edit',
      name: 'tenant_new_contract_template_list_edit',
      component: () =>
        import(
          '@/pages/organize/Contract/views/ContractTemplateMangment/edit.vue'
        ),
      meta: {
        title: '合同模板编辑',
        logEvent: '',
        keepAlive: false,
        parent: [
          {
            path: '/tenantNew/contractTemplate/list',
            name: 'tenant_new_contract_template',
            title: '合同模板管理',
          },
          {
            path: '/finance/entrustWithhold/contractTemplate',
            name: 'entrustWithholdContractTemplate',
            title: '委托划扣协议模板',
          },
        ],
      },
    },
    {
      path: '/tenantNew/contractTemplate/add',
      name: 'tenant_new_contract_template_list_create',
      component: () =>
        import(
          '@/pages/organize/Contract/views/ContractTemplateMangment/add.vue'
        ),
      meta: {
        title: '合同模板新增',
        logEvent: '',
        keepAlive: false,
        parent: [
          {
            path: '/tenantNew/contractTemplate/list',
            name: 'tenant_new_contract_template',
            title: '合同模板管理',
          },
          {
            path: '/finance/entrustWithhold/contractTemplate',
            name: 'entrustWithholdContractTemplate',
            title: '委托划扣协议模板',
          },
        ],
      },
    },
    // 网约运营数据共享[集团]
    {
      path: '/tenant/linkage/secret/list',
      name: 'linkage_board_config_secretList',
      component: () => import('@/pages/organize/linkage/secret/list'),
      meta: { title: '网约运营数据共享', logEvent: '' },
    },
    // e签宝配置
    {
      path: '/tenant/eSign/config/list',
      name: 'esign_config_list',
      component: () => import('@/pages/organize/eSign/list/index.vue'),
      meta: { title: 'E签宝配置', logEvent: '' },
    },
    // e签宝使用明细
    {
      path: '/tenant/eSign/chargeRecord/list',
      name: 'chargeRecord',
      component: () => import('@/pages/organize/eSign/chargeRecordList'),
      meta: { title: '使用明细', logEvent: '' },
    },
    // 份额购买记录
    {
      path: '/tenant/eSign/purchaseRecord/list',
      name: 'purchaseRecordList',
      component: () => import('@/pages/organize/eSign/purchaseRecordList'),
      hidden: true,
      meta: { title: '份额购买记录', logEvent: '', keepAlive: false },
    },
    // 以下是门店相关
    {
      path: '/companyNew/company/storeManage/list',
      name: 'company_store_list',
      component: () => import('@/pages/shop/store/list/index.vue'),
      meta: { title: '门店列表' },
    },
    {
      path: '/companyNew/company/storeManage/add',
      name: 'company_handle_store',
      component: () => import('@/pages/shop/store/add/index.vue'),
      meta: {
        title: '新增门店',
        parent: [
          {
            path: '/companyNew/company/storeManage/list',
            name: 'company_store_list',
            title: '门店列表',
          },
        ],
      },
      hidden: true,
    },
    {
      path: '/companyNew/company/storeManage/detail',
      name: 'company_store_detail',
      component: () => import('@/pages/shop/store/detail/index.vue'),
      meta: { title: '门店详情', keepAlive: false },
      hidden: true,
    },
  ],
}
export default group
